var exports = {
  "j": "x93eb46d8--ba3f06--section-heading",
};

module.exports = exports;
